module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst navCode = config.navCode || 'main'\nconst showInlineSubNavElements = config.showInlineSubNavElements && !config.horizontal\nconst additionalClasses = []\nif(config.horizontal){\nadditionalClasses.push('horizontal')\n}\nif(config.alignRight){\nadditionalClasses.push('alignRight')\n}\nif(model.collapsed){\nadditionalClasses.push('collapsed')\n}\nconst additionalAttributes = []\nif(additionalClasses.length > 0){\nadditionalAttributes.push(`class=\"${additionalClasses.join(' ')}\"`)\n}\nlet childIndicatorSymbol = 'fi fi-caret-right'\nif(config.horizontal) {\nchildIndicatorSymbol = 'fi fi-caret-down'\n} else if(config.alignRight){\nchildIndicatorSymbol = 'fi fi-caret-left'\n}\nlet childIndicatorSymbolActive = 'fi fi-caret-down'\nif(config.horizontal){\nchildIndicatorSymbolActive = childIndicatorSymbol\n}\n%><div <%- additionalAttributes.join(' ') %>><%\n%><ul><%\nfor(const {entity, meta: { level = 0 }} of helpers.nav.each(resourceData, navCode)){\nconst {\nkey = '',\nnavConfig: {\nisUserProfile = false,\nshowSubNavSymbols = false,\nforceCollapsedTitle = false,\nicon = '',\ntitle = '',\n} = {},\n} = entity || {}\nif(!showInlineSubNavElements && level > 0){\ncontinue\n}\nconst additionalEntityClasses = []\nif(forceCollapsedTitle){\nadditionalEntityClasses.push('forceCollapsedTitle')\n}\nif(isUserProfile){\nadditionalEntityClasses.push('isUserProfile')\n}\n%><li data-key=\"<%- key %>\" data-level=\"<%- level %>\" class=\"<%= additionalEntityClasses.join(' ') %>\"><%\nfor(const {entity: child, meta: { level: childLevel = 0}, first, last} of helpers.nav.each(resourceData, navCode, { entityKey: key, serveEntityChildren: level < 1, serveFallback: true })){\nif(first){\n%><div class=\"entry\"><%\n%><div class=\"symbol\"><%\nif(icon && level < 1){\n%><i class=\"<%- icon %>\"></i><%\n}\n%></div><%\n%><div class=\"title\"><%\n%><%= title %><%\n%></div><%\nif(config.showChildrenIndicator && child !== null && level < 1){\n%><div class=\"indicator\"><%\n%><i class=\"inactive <%= childIndicatorSymbol %>\"></i><%\n%><i class=\"active <%= childIndicatorSymbolActive %>\"></i><%\n%></div><%\n}\n%></div><%\nif(level < 1){\n%><div class=\"outerSubNav<%= child === null ? ' headOnly' : '' %>\"><%\n%><ul><%\n%><li class=\"head<%= child === null ? ' info' : '' %>\" data-key=\"<%- key %>\" data-level=\"<%- level %>\"><%\n%><div class=\"entry\"><%\n%><div class=\"title\"><%\n%><%= title %><%\n%></div><%\n%></div><%\n%></li><%\n}\n}\nif(child) {\nconst {\nkey = '',\nnavConfig: {\ntitle = '',\nicon = '',\n} = {},\n} = child\n%><li data-key=\"<%- key %>\" data-level=\"<%- childLevel %>\"><%\n%><div class=\"entry\"><%\nif(showSubNavSymbols && icon){\n%><div class=\"symbol\"><%\n%><i class=\"<%- icon %>\"></i><%\n%></div><%\n}\n%><div class=\"title\"><%\n%><%= title %><%\n%></div><%\n%></div><%\n%></li><%\n}\nif(last && level < 1){\n%></ul><%\n%></div><%\n}\n}\n%></li><%\n}\nif(config.collapsable){\n%><li class=\"collapseToggle\" data-level=\"0\"><%\n%><div class=\"entry\"><%\n%><div class=\"symbol\"><%\n%><i class=\"fi fi-caret-right collapsed\"></i><%\n%><i class=\"fi fi-caret-left expanded\"></i><%\n%></div><%\n%><div class=\"title\"><%\n%><%= storage.__('nav.collapseToggle.expanded') %><%\n%></div><%\n%></div><%\n%></li><%\n}\n%></ul><%\n%></div>"
  , __filename = "components/templates/nav/nav.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const navCode = config.navCode || 'main'
const showInlineSubNavElements = config.showInlineSubNavElements && !config.horizontal
const additionalClasses = []
if(config.horizontal){
additionalClasses.push('horizontal')
}
if(config.alignRight){
additionalClasses.push('alignRight')
}
if(model.collapsed){
additionalClasses.push('collapsed')
}
const additionalAttributes = []
if(additionalClasses.length > 0){
additionalAttributes.push(`class="${additionalClasses.join(' ')}"`)
}
let childIndicatorSymbol = 'fi fi-caret-right'
if(config.horizontal) {
childIndicatorSymbol = 'fi fi-caret-down'
} else if(config.alignRight){
childIndicatorSymbol = 'fi fi-caret-left'
}
let childIndicatorSymbolActive = 'fi fi-caret-down'
if(config.horizontal){
childIndicatorSymbolActive = childIndicatorSymbol
}

    ; __line = 28
    ; __append("<div ")
    ; __append( additionalAttributes.join(' ') )
    ; __append(">")
    ; 

    ; __line = 29
    ; __append("<ul>")
    ; 
for(const {entity, meta: { level = 0 }} of helpers.nav.each(resourceData, navCode)){
const {
key = '',
navConfig: {
isUserProfile = false,
showSubNavSymbols = false,
forceCollapsedTitle = false,
icon = '',
title = '',
} = {},
} = entity || {}
if(!showInlineSubNavElements && level > 0){
continue
}
const additionalEntityClasses = []
if(forceCollapsedTitle){
additionalEntityClasses.push('forceCollapsedTitle')
}
if(isUserProfile){
additionalEntityClasses.push('isUserProfile')
}

    ; __line = 51
    ; __append("<li data-key=\"")
    ; __append( key )
    ; __append("\" data-level=\"")
    ; __append( level )
    ; __append("\" class=\"")
    ; __append(escapeFn( additionalEntityClasses.join(' ') ))
    ; __append("\">")
    ; 
for(const {entity: child, meta: { level: childLevel = 0}, first, last} of helpers.nav.each(resourceData, navCode, { entityKey: key, serveEntityChildren: level < 1, serveFallback: true })){
if(first){

    ; __line = 54
    ; __append("<div class=\"entry\">")
    ; 

    ; __line = 55
    ; __append("<div class=\"symbol\">")
    ; 
if(icon && level < 1){

    ; __line = 57
    ; __append("<i class=\"")
    ; __append( icon )
    ; __append("\"></i>")
    ; 
}

    ; __line = 59
    ; __append("</div>")
    ; 

    ; __line = 60
    ; __append("<div class=\"title\">")
    ; 

    ; __line = 61
    ; __append(escapeFn( title ))
    ; 

    ; __line = 62
    ; __append("</div>")
    ; 
if(config.showChildrenIndicator && child !== null && level < 1){

    ; __line = 64
    ; __append("<div class=\"indicator\">")
    ; 

    ; __line = 65
    ; __append("<i class=\"inactive ")
    ; __append(escapeFn( childIndicatorSymbol ))
    ; __append("\"></i>")
    ; 

    ; __line = 66
    ; __append("<i class=\"active ")
    ; __append(escapeFn( childIndicatorSymbolActive ))
    ; __append("\"></i>")
    ; 

    ; __line = 67
    ; __append("</div>")
    ; 
}

    ; __line = 69
    ; __append("</div>")
    ; 
if(level < 1){

    ; __line = 71
    ; __append("<div class=\"outerSubNav")
    ; __append(escapeFn( child === null ? ' headOnly' : '' ))
    ; __append("\">")
    ; 

    ; __line = 72
    ; __append("<ul>")
    ; 

    ; __line = 73
    ; __append("<li class=\"head")
    ; __append(escapeFn( child === null ? ' info' : '' ))
    ; __append("\" data-key=\"")
    ; __append( key )
    ; __append("\" data-level=\"")
    ; __append( level )
    ; __append("\">")
    ; 

    ; __line = 74
    ; __append("<div class=\"entry\">")
    ; 

    ; __line = 75
    ; __append("<div class=\"title\">")
    ; 

    ; __line = 76
    ; __append(escapeFn( title ))
    ; 

    ; __line = 77
    ; __append("</div>")
    ; 

    ; __line = 78
    ; __append("</div>")
    ; 

    ; __line = 79
    ; __append("</li>")
    ; 
}
}
if(child) {
const {
key = '',
navConfig: {
title = '',
icon = '',
} = {},
} = child

    ; __line = 90
    ; __append("<li data-key=\"")
    ; __append( key )
    ; __append("\" data-level=\"")
    ; __append( childLevel )
    ; __append("\">")
    ; 

    ; __line = 91
    ; __append("<div class=\"entry\">")
    ; 
if(showSubNavSymbols && icon){

    ; __line = 93
    ; __append("<div class=\"symbol\">")
    ; 

    ; __line = 94
    ; __append("<i class=\"")
    ; __append( icon )
    ; __append("\"></i>")
    ; 

    ; __line = 95
    ; __append("</div>")
    ; 
}

    ; __line = 97
    ; __append("<div class=\"title\">")
    ; 

    ; __line = 98
    ; __append(escapeFn( title ))
    ; 

    ; __line = 99
    ; __append("</div>")
    ; 

    ; __line = 100
    ; __append("</div>")
    ; 

    ; __line = 101
    ; __append("</li>")
    ; 
}
if(last && level < 1){

    ; __line = 104
    ; __append("</ul>")
    ; 

    ; __line = 105
    ; __append("</div>")
    ; 
}
}

    ; __line = 108
    ; __append("</li>")
    ; 
}
if(config.collapsable){

    ; __line = 111
    ; __append("<li class=\"collapseToggle\" data-level=\"0\">")
    ; 

    ; __line = 112
    ; __append("<div class=\"entry\">")
    ; 

    ; __line = 113
    ; __append("<div class=\"symbol\">")
    ; 

    ; __line = 114
    ; __append("<i class=\"fi fi-caret-right collapsed\"></i>")
    ; 

    ; __line = 115
    ; __append("<i class=\"fi fi-caret-left expanded\"></i>")
    ; 

    ; __line = 116
    ; __append("</div>")
    ; 

    ; __line = 117
    ; __append("<div class=\"title\">")
    ; 

    ; __line = 118
    ; __append(escapeFn( storage.__('nav.collapseToggle.expanded') ))
    ; 

    ; __line = 119
    ; __append("</div>")
    ; 

    ; __line = 120
    ; __append("</div>")
    ; 

    ; __line = 121
    ; __append("</li>")
    ; 
}

    ; __line = 123
    ; __append("</ul>")
    ; 

    ; __line = 124
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/nav/nav.ejs

}